import { Modal, Form, Button } from 'react-bootstrap';
import Select from 'react-select';

const MoveOrCopyTaskModal = ({
    show,
    onHide,
    moveOrCopyType,
    setMoveOrCopyType,
    targetProject,
    setTargetProject,
    targetTaskList,
    setTargetTaskList,
    projectOptions,
    taskListOptions,
    onSubmit
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Move or Copy Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className='mb-3'>
                        <Form.Label>Action Type</Form.Label>
                        <div className='d-flex gap-3'>
                            <Form.Check
                                inline
                                type="radio"
                                name="moveOrCopy"
                                label="Move"
                                checked={moveOrCopyType === 'move'}
                                onChange={() => setMoveOrCopyType('move')}
                            />
                            <Form.Check
                                inline
                                type="radio"
                                name="moveOrCopy"
                                label="Copy"
                                checked={moveOrCopyType === 'copy'}
                                onChange={() => setMoveOrCopyType('copy')}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Select Target Project <span className='text-danger'>*</span></Form.Label>
                        <Select
                            value={targetProject}
                            onChange={(val) => {
                                setTargetProject(val);
                                setTargetTaskList(null);
                            }}
                            options={projectOptions}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder=""
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Select Target Task List <span className='text-danger'>*</span></Form.Label>
                        <Select
                            value={targetTaskList}
                            onChange={setTargetTaskList}
                            options={taskListOptions}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder=""
                            isClearable
                            isDisabled={!targetProject}
                        />
                        {moveOrCopyType === 'move' && (
                            <Form.Text className="p-tag fs-12 mt-1">
                                Moving this task will remove it from its current location and place it in the selected task list.
                            </Form.Text>
                        )}
                        {moveOrCopyType === 'copy' && (
                            <Form.Text className="p-tag fs-12 mt-1">
                                Copying this task will create a duplicate in the selected task list while keeping the original.
                            </Form.Text>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    onClick={onSubmit}
                >
                    {moveOrCopyType === 'move' ? 'Move Task' : 'Copy Task'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MoveOrCopyTaskModal;
